import api from './api';
import type { Venue } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/logo`;

export interface VenueLogoMetadata {
  logoUrl: string | null;
  originalName: string | null;
  mimeType: string | null;
  sizeBytes: number | null;
  uploadedAt: string | null;
}

const venueLogoService = {
  /** Returns the logo metadata, or null when the venue has no logo (server returns 404). */
  getMetadata: async (venueId: string): Promise<VenueLogoMetadata | null> => {
    try {
      const response = await api.get(base(venueId));
      return response.data;
    } catch (err: any) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  },

  /**
   * Uploads (or replaces) a logo for a venue. The server returns the updated
   * Venue document so callers can refresh the logoUrl reference.
   */
  upload: async (venueId: string, file: File): Promise<Venue> => {
    const form = new FormData();
    form.append('file', file);
    const response = await api.post(base(venueId), form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /** Removes the logo. Idempotent — server returns 204 either way. */
  remove: async (venueId: string): Promise<void> => {
    await api.delete(base(venueId));
  },
};

export default venueLogoService;
